
class CapViewRoutingManagement {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_routing_management'
}

function create(config) {
  return new CapViewRoutingManagement(config)
}

export default {
  key,
  create,
}
